// import React, {useEffect, useState} from "react";
// import { BrowserRouter as Router, Routes, Route, Link, Outlet, useNavigate } from 'react-router-dom';
// import './UserAccountPage.css';
// import Logout from './Logout';
// import Orders from './Orders'
// import AccountSettings from './AccountSettings'
// import Register from './Register';
// import BusinessDashboard from "./biz/BusinessDashboard.js";
// import RegisterBusiness from "./biz/RegisterBusiness.js"
// import { API_URL } from '../services/api';

// // import { fetchBusinesses } from '../services/api';

// const UserAccountPage = () => {
//   return (

//       <div class="UserAccountPage">
//       <div class="pageHeader">
//         <p>Account</p>
//       </div>
//         <div class="options-UAP">
//           <li><Link to="logout">Logout</Link> </li>
//           <li><Link to="account-settings">Account Settings</Link> </li>
//           <li> <Link to="orders">My Orders</Link> </li>
//           <li> <Link to="registerbusiness">Sell On Verdure!</Link> </li>
//           <li> <Link to="business">Business Dashboard</Link></li>
//           {/* <li> <Link to="/business">Business Dashboard</Link></li> */}
//         </div>
//         <div className="options-contentSection">
//           <Outlet /> {}
//         </div>
//       </div>
//   );
// };

// export const UserAccountRoutes = () => {
//   return (
//     <Routes>
//             <Route path="/" element={<UserAccountPage />}>
//               <Route path="logout" element={<Logout />} />
//               <Route path="account-settings" element={<AccountSettings />} />
//               <Route path="orders" element={<Orders />} />
//               <Route path="registerbusiness" element={<RegisterBusiness />} />
//               <Route path="business" element={<BusinessDashboard />} />
//             </Route>
//           </Routes>
//   );
// };

// export default UserAccountPage;

// import React, { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Link, Outlet } from 'react-router-dom';
// import axios from 'axios';
// import './UserAccountPage.css';

// import Logout from './Logout';
// import Orders from './Orders';
// import AccountSettings from './AccountSettings';
// import RegisterBusiness from "./biz/RegisterBusiness.js";
// import BusinessDashboard from "./biz/BusinessDashboard.js";
// import { API_URL } from '../services/api';

// const UserAccountPage = () => {
//   const [hasBusiness, setHasBusiness] = useState(false);

//   useEffect(() => {
//     axios.get(`${API_URL}api/user-has-business/`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//       },
//       withCredentials: true
//     })
//     .then(res => {
//       setHasBusiness(res.data.has_business);
//     })
//     .catch(err => {
//       console.error("Error checking business status:", err);
//       window.location.href = '/login'; // Redirect to login if there's an error
//     });
//   }, []);

//   return (
//     <div className="UserAccountPage">
//       <div className="pageHeader">
//         <p>Account</p>
//       </div>
//       <div className="options-UAP">
//         <li><Link to="logout">Logout</Link></li>
//         <li><Link to="account-settings">Account Settings</Link></li>
//         <li><Link to="orders">My Orders</Link></li>
//         <li><Link to="registerbusiness">Sell On Verdure!</Link></li>
//         {hasBusiness && <li><Link to="business">Business Dashboard</Link></li>}
//       </div>
//       <div className="options-contentSection">
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// // Route definitions including nested routing for UserAccountPage
// export const UserAccountRoutes = () => {
//   return (
//     <Routes>
//       <Route path="/" element={<UserAccountPage />}>
//         <Route path="logout" element={<Logout />} />
//         <Route path="account-settings" element={<AccountSettings />} />
//         <Route path="orders" element={<Orders />} />
//         <Route path="registerbusiness" element={<RegisterBusiness />} />
//         <Route path="business" element={<BusinessDashboard />} />
//       </Route>
//     </Routes>
//   );
// };

// export default UserAccountPage;

import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
} from "react-router-dom";
import axios from "axios";
import "./UserAccountPage.css";

import Logout from "./Logout";
import Orders from "./Orders";
import AccountSettings from "./AccountSettings";
import RegisterBusiness from "./biz/RegisterBusiness.js";
import BusinessDashboard from "./biz/BusinessDashboard.js";
import { API_URL } from "../services/api";

const UserAccountPage = () => {
  const [hasBusiness, setHasBusiness] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    setLoading(true); // Set loading to true when component mounts

    axios
      .get(`${API_URL}api/user-has-business/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        setHasBusiness(res.data.has_business);
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch((err) => {
        console.error("Error checking business status:", err);
        setLoading(false); // Set loading to false on error
        window.location.href = "/login"; // Redirect to login if there's an error
      });
  }, []);

  return (
    <div className="UserAccountPage">
      {/* Loading overlay */}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {/* <div className="UAPpageHeader">
        <p>Account</p>
      </div> */}

      <div className="options-UAP">
        <li>
          <Link to="logout">Logout</Link>
        </li>
        <li>
          <Link to="account-settings">Account Settings</Link>
        </li>
        <li>
          <Link to="orders">My Orders</Link>
        </li>
        <li>
          <Link to="registerbusiness">Sell On Verdure!</Link>
        </li>
        {hasBusiness && (
          <li>
            <Link to="business">Business Dashboard</Link>
          </li>
        )}
      </div>
      <div className="options-contentSection">
        <Outlet />
      </div>
    </div>
  );
};

// Route definitions including nested routing for UserAccountPage
export const UserAccountRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UserAccountPage />}>
        <Route path="logout" element={<Logout />} />
        <Route path="account-settings" element={<AccountSettings />} />
        <Route path="orders" element={<Orders />} />
        <Route path="registerbusiness" element={<RegisterBusiness />} />
        <Route path="business" element={<BusinessDashboard />} />
      </Route>
    </Routes>
  );
};

export default UserAccountPage;
